import { Injectable } from '@angular/core';
import { Constants } from '../config/Constants';
import { Speaker } from '../models/speaker';

import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';

@Injectable()
export class ExportImportSpeakersService {

  arrayBuffer: any;

  constructor(private datePipe: DatePipe) { }

  importSpeakers(selectedFile: File) {
    return new Promise<any>((resolve, reject) => {
      let fileReader = new FileReader();
      fileReader.onload = (e) => {
        /* read workbook */
        this.arrayBuffer = fileReader.result;
        let data = new Uint8Array(this.arrayBuffer);
        let arr = new Array();
        for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
        let bstr = arr.join("");
        let workbook = XLSX.read(bstr, { type: "binary" });
        /* grab first sheet */
        let first_sheet_name = workbook.SheetNames[0];
        let worksheet = workbook.Sheets[first_sheet_name];
        /* save data */
        let speakers = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        if (speakers.length) {
          resolve(speakers);
        } else {
          reject("Empty File.")
        }
      }
      fileReader.readAsArrayBuffer(selectedFile);
    });
  }

  generateFile(speakers: any, event_alias: string,screen:string) {
    let fileName = '' + event_alias + '_'+screen+'_' + this.datePipe.transform(new Date(), 'ddMMyyyy') + '.xlsx';
    let worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(speakers);
    let workbook: XLSX.WorkBook = { Sheets: { 'Speakers': worksheet }, SheetNames: ['Speakers'] };
    XLSX.writeFile(workbook, fileName, );
  }
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/services/export-import-speakers.service.ts